import React from "react"

import AnimationWrapper from "../../internal/animationWrapper/AnimationWrapper";
import BottleSlide from "./animations/bottleSlider";
import RocksFalling from "./animations/rocksFalling";
import RocksOnTrack from "./animations/rocksOnTrack";
import RodsFalling from "./animations/rodsFalling";
import Roller from "./animations/roller";
import Spray from "./animations/spray";
import BilletStack from "./animations/billetStack";

const AnimationPanel = ({ blok }) => {
    const animation = blok.animation;
    switch(animation){
        case "rocks": 
            return (
            <AnimationWrapper blok={blok}>
                <RocksOnTrack/>
            </AnimationWrapper>);
            
        case "falling-rocks":
            return (
                <AnimationWrapper blok={blok}>
                    <RocksFalling/>
                </AnimationWrapper>);
            
        case "rods":
            return (
                <AnimationWrapper blok={blok}>
                    {/* <RodsFalling/> */}
                    <BilletStack/>
                </AnimationWrapper>);
            
        case "roller":
            return (
                <AnimationWrapper blok={blok}>
                    <Roller/>
                </AnimationWrapper>);
            
        case "bottle-slide":
            return (
                <AnimationWrapper blok={blok}>
                    <BottleSlide/>
                </AnimationWrapper>);
            
        case "spray":
            return (
                <AnimationWrapper blok={blok}>
                    <Spray/>
                </AnimationWrapper>);
            
        default:
            return(
            <AnimationWrapper blok={blok}>
                <h4>Select an Animation</h4>
            </AnimationWrapper>  
            );  
    }
}
    
 
export default AnimationPanel;